module.exports = __webpack_public_path__ + "img/C1.c7a64593.png";